<!-- bot  -->
<div class="boot_session">
  <div class="botdetails">
      <div class="closebtn">
          <i (click)="openbot()" class="fa fa-times" aria-hidden="true"></i>
      </div>
  <iframe class="boots" data-src="https://aps-chatbot-ui-prod.azurewebsites.net/chatbot" src="about:blank" frameborder="0">
      
  </iframe>
  </div>
  <!-- <div class="botdisplay " (click)="openbot()" >
    <img src="/assets/image/icons/assistant.png" width="100%" height="100%">
  </div> -->
</div>

<!-- slider -->

<div class="container-item">
  <div class="swiper-container">
    <swiper
      [navigation]="true"
      [pagination]="true"
      [effect]="'fade'"
      [autoplay]="{
        delay: 8000,
        disableOnInteraction: false
      }"
      class="mySwiper"
    >
      <ng-template swiperSlide class="swiper-slide">
        <div
          class="slider-data"
          style="background-image: url(assets/image/slider-1.jpg)"
        >
          <div
            class="sliderbar-cover"
            style="background-image: url(assets/image/slider-bg-header.png)"
          >
            <div class="sliderdata">
              <div class="slider-content">
                <h1>
                  Welcome to the world of
                  <br> <span>Antique phonographs, <br> Gramophones</span>  and <br> <span>Recordings </span>
              
              
                </h1>

             
                <!-- <p>
                  The Antique Phonograph Society is a worldwide <br> organization of
                  people...
                </p> -->
                <a   style="cursor:pointer;" (click)="openregpage()"  class="slider-brn-join">JOIN US </a>
              </div>
            </div>
            <div class="nav-slider-icon">
              <img src="assets/image/slider-dirt.svg" alt="" srcset="" />
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template swiperSlide class="swiper-slide">
        <div
          class="slider-data"
          style="background-image: url(assets/image/slider-2.jpg)"
        >
          <div
            class="sliderbar-cover"
            style="background-image: url(assets/image/slider-bg-header.png)"
          >
            <div class="sliderdata">
              <div class="slider-content">
                <h1>
                  Joining our community <br> is free. Paid members <br> receive 
                  <span> full access </span> to   <span> our <br> research </span> and <span> resources, <br> discounts,</span>
                  and more.
                </h1>
                <a   style="cursor:pointer;" (click)="openregpage()"  class="slider-brn-join">JOIN US </a>
              </div>
            </div>
            <div class="nav-slider-icon">
              <img src="assets/image/slider-dirt.svg" alt="" srcset="" />
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template swiperSlide class="swiper-slide">
        <div
          class="slider-data"
          style="background-image: url(assets/image/slider-3.jpg)"
        >
          <div
            class="sliderbar-cover"
            style="background-image: url(assets/image/slider-bg-header.png)"
          >
            <div class="sliderdata">
              <div class="slider-content">
                <h1>
                  Use our <span>Online Forum </span> <br> to post questions and meet <br> experienced collectors.  <br>Use this site for research  <br> and to learn about  <br> upcoming events
                  
                </h1>
                <a   style="cursor:pointer;" (click)="openregpage()"  class="slider-brn-join">JOIN US </a>
              </div>
            </div>
            <div class="nav-slider-icon">
              <img src="assets/image/slider-dirt.svg" alt="" srcset="" />
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template swiperSlide class="swiper-slide">
        <div
          class="slider-data"
          style="background-image: url(assets/image/slider-4.jpg)"
        >
          <div
            class="sliderbar-cover"
            style="background-image: url(assets/image/slider-bg-header.png)"
          >
            <div class="sliderdata">
              <div class="slider-content">
                <h1>
                  <span>The Grammy Awards </span> <br> are named after the <br> gramophone – the <br> name of the first disc <br> playing phonographs.
            
                  
                </h1>
                <a   style="cursor:pointer;" (click)="openregpage()"  class="slider-brn-join">JOIN US </a>
              </div>
            </div>
            <div class="nav-slider-icon">
              <img src="assets/image/slider-dirt.svg" alt="" srcset="" />
            </div>
          </div>
        </div>
      </ng-template>
    </swiper>
  </div>
</div>

<!-- Notification -->

<!-- <section class="notification"  >
  <span class="not-viewer">
    <i class="fa fa-angle-double-right" aria-hidden="true"></i>
  </span>
  <div class="not-items">
    <span class="not-close-viewer">
      <i class="fa fa-angle-double-right" aria-hidden="true"></i>
    </span>
     <div class="not-logo">
      <img src="assets/image/logo.png" alt="" srcset="" />
    </div> -
    <div class="notcontent">
      <div>
      <ng-template ngFor let-item [ngForOf]="notifydata" let-i="index" >
      <h4>{{item.Nothead}}</h4>

      <div style="margin-top: 1rem;" [innerHtml]="item.notDetails"></div>
    </ng-template>
    </div>
  </div>
  </div>
</section> -->
<div class="notify">
  <div class="sideicon w3-animate-right">
      <div class="icons">
        <i class="fa fa-angle-double-right" aria-hidden="true"></i>
      </div>
  </div>
  <div class="content w3-animate-right" id="rightMenu" style="display:none;right:0;">
      <div class="close">
        <i class="fa fa-times" aria-hidden="true"></i>
      </div>
  <div class="details">
     <div class="listdata">
      <ng-template ngFor let-item [ngForOf]="notifydata" let-i="index" >
        <h4>{{item.Nothead}}</h4>
  
        <div style="margin-top: 1rem;" [innerHtml]="item.notDetails"></div>
      </ng-template>
   

     </div>
  </div>
  </div>
</div>

<!-- end notification -->

<!-- welcome session  -->
<div class="wellcom-session" style="background-image: url(assets/image/w.png)">
  
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-3"></div>
      <div class="col-md-4">
        <div class="welcome-head">
          <h2>
            WELCOME TO <br />
            <span (click)="goDown2()"> THE ANTIQUE PHONOGRAPH SOCIETY</span>
          </h2>
        </div>
      </div>
      <div class="col-md-5">
        <div class="welcome-content">
          <p>
            The Antique Phonograph Society is a worldwide organization of people
            with a common passion for the preservation of antique phonographs,
            gramophones and records. We encourage everyone who is interested in
            these wonderful machines and recordings from the past to join us by
            enjoying and contributing to our organization.
          </p>
          <p style="margin:0;">Antique Phonograph Society activities include our:</p>
          <ul>
            <li>Free online Forum and Facebook sites (free)</li>
            <li>
              Library of free articles and information as well as over 30,000
              pages of phonograph and record research material for paid members
            </li>
            <li>
              Quarterly journal, The Antique Phonograph¸ with articles for new
              hobbyists as well as advanced collectors
            </li>
            <li>EXPO events with discounted pricing for members</li>
          </ul>
          <a  style="cursor:pointer;" (click)="openregpage()" class="join-btn">JOIN US</a>
        </div>
      </div>
    </div>
  </div>
</div>

<!--about antique  -->
<!-- <div class="about-antique">
  <div class="about-header">
    <h3>HELP ME IDENTIFY MY <span>ANTIQUE PHONOGRAPH </span></h3>
  </div> -->
<!-- <div class="about-items">
    <div class="about-item-img">
      <img src="assets/image/Edison.png" alt="" srcset="" />
    </div>
    <div class="about-item-content">
      <h4>
        Did you ever wonder
        <span>how sound comes out of a CD or an iPod?</span> Or what a
        <span> Grammy Award </span>
        is modeled after? It would take an electrical engineer to answer the
        first question, but the Grammy is simple: it’s a phonograph -the
        great-grandfather to all sound reproducing inventions.
      </h4>
      <a href="#" class="join-btn m-item-top"
        >MORE ABOUT ANTIQUE PHONOGRAPH ?</a
      >
    </div>
  </div>
  <div class="clear"></div>
  <div class="about-btm-image">
    <div class="container">
      <div class="row">
        <div class="col-lg-5"></div>
        <div class="col-lg-6">
          <div class="item-btm-content">
            <p>
              This <span>Victor | dates</span> from about 1905 and plays disc
              records.
            </p>
          </div>
        </div>
      </div>
    </div>
    <img src="assets/image/line-image.svg" alt="" srcset="" />
  </div> -->
<!-- HELP AND IDENTIFY -->
<!-- <div class="identity">
        <div class="col-element-1">
          <img src="assets/image/Edison@2x.png" alt="" srcset="" />
        </div>
        <div class="col-element-2">
          <img
            src="assets/image/Picture-tabletop-inside-cylinder@2x.png"
            alt=""
            srcset=""
          />
        </div>
        <div class="col-element-3">
          <img src="assets/image/tabletop-inside-disk@2x.png" alt="" srcset="" />
        </div>
      </div>
      <div class="identity">
        <div class="col-element-4">
          <img src="assets/image/Victor-I-dates@2x.png" alt="" srcset="" />
        </div>
        <div class="col-element-5">
          <img src="assets/image/slide-4@2x.png" alt="" srcset="" />
        </div>
      </div>
      <div class="bottom-image">
        <a href="#" class="info-more-btn"
          >CLICK HERE FOR <br />
          MORE INFORMATION</a
        >
        <img src="assets/image/btm-image.svg" alt="" sizes="" srcset="" />
      </div> -->
<!-- HELP AND IDENTIFY new edit -->
<!-- <div class="about-items top-search">
        <div class="srtitems">
          <div class="row">
            <div class="col-md-6">
              <input type="text" name="" id="" class="form-control" placeholder="EDISON">
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1" checked>
                    <label class="form-check-label" for="exampleRadios1">
                      By Company
                    </label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1" checked>
                    <label class="form-check-label" for="exampleRadios1">
                      By Model
                    </label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1" checked>
                    <label class="form-check-label" for="exampleRadios1">
                      By Category
                    </label>
                  </div>
                </div>
              </div>
            </div>
         
          </div>
        </div>

          <div class="help-detailsinfo">
            <div class="row">
              <div class="col-md-3">
                <div class="help-itemList">
                  <p>This is an example of an <span>Edison Standard</span>Edison Standard, Cylinder Phonograph, Table-top model with external horn.</p>
                <a class="clickbtn-help" href="#" >
                  CLICK HERE
                </a>
                <p>For More Information</p>
                <div class="help-image">
                  <img src="assets/image/Edison.png" alt="" srcset="">
                </div>
                </div>
               
              </div>
              <div class="col-md-3">
                <div class="help-itemList">
                  <p>This is an example of an <span>Edison Standard</span>Edison Standard, Cylinder Phonograph, Table-top model with external horn.</p>
                <a class="clickbtn-help" href="#" >
                  CLICK HERE
                </a>
                <p>For More Information</p>
                <div class="help-image">
                  <img src="assets/image/Edison.png" alt="" srcset="">
                </div>
                </div>
               
              </div>
              <div class="col-md-3">
                <div class="help-itemList">
                  <p>This is an example of an <span>Edison Standard</span>Edison Standard, Cylinder Phonograph, Table-top model with external horn.</p>
                <a class="clickbtn-help" href="#" >
                  CLICK HERE
                </a>
                <p>For More Information</p>
                <div class="help-image">
                  <img src="assets/image/Edison.png" alt="" srcset="">
                </div>
                </div>
               
              </div>
              <div class="col-md-3">
                <div class="help-itemList">
                  <p>This is an example of an <span>Edison Standard</span>Edison Standard, Cylinder Phonograph, Table-top model with external horn.</p>
                <a class="clickbtn-help" href="#" >
                  CLICK HERE
                </a>
                <p>For More Information</p>
                <div class="help-image">
                  <img src="assets/image/Edison.png" alt="" srcset="">
                </div>
                </div>
               
              </div>
            </div>
            <swiper
    [slidesPerView]="4"
    [spaceBetween]="30"
    [slidesPerGroup]="4"
    [loop]="true"
    [loopFillGroupWithBlank]="true"
    [navigation]="true"
    class="mySwiper"
  >
    <ng-template swip
    erSlide>              <div class="help-itemList">
      <p>This is an example of an <span>Edison Standard</span>Edison Standard, Cylinder Phonograph, Table-top model with external horn.</p>
    <a class="clickbtn-help" href="#" >
      CLICK HERE
    </a>
    <p>For More Information</p>
    <div class="help-image">
      <img src="assets/image/Edison.png" alt="" srcset="">
    </div>
    </div>
      </ng-template
    ><ng-template swiperSlide>         <div class="help-itemList">
                  <p>This is an example of an <span>Edison Standard</span>Edison Standard, Cylinder Phonograph, Table-top model with external horn.</p>
                <a class="clickbtn-help" href="#" >
                  CLICK HERE
                </a>
                <p>For More Information</p>
                <div class="help-image">
                  <img src="assets/image/Edison.png" alt="" srcset="">
                </div>
                </div></ng-template
    ><ng-template swiperSlide>Slide 3</ng-template
    ><ng-template swiperSlide>Slide 4</ng-template
    ><ng-template swiperSlide>Slide 5</ng-template
    ><ng-template swiperSlide>Slide 6</ng-template
    ><ng-template swiperSlide>Slide 7</ng-template
    ><ng-template swiperSlide>Slide 8</ng-template
    ><ng-template swiperSlide>Slide 9</ng-template>
  </swiper>

          </div>

          <div class="direction-info">
            <div class="row">
              <div class="col-md-6">
              <div class="help-info-guid">
                <p> Machene is not listed? </p>
                <a href="#" class="help-info-guid-path">
                  GO TO FORUM
                </a>

              </div>
                
              </div>
              <div class="col-md-6">
                <div class="help-info-guid">
                  <p> Take me to the </p>
                  <a href="#" class="help-info-guid-path">
                    PRICE GUIDE
                  </a>
  
                </div>
                  
                </div>
            </div>
          </div>
        

      </div>
    </div> -->
<!-- slider close -->

<!-- about antique -->

<div
  class="about-antique"
  style="
    background-image: url(assets/image/HELP-ME-IDENTIFY-my-Antique-Phonograph-BG.jpg);
  "
>
  <div class="about-heading">
    <div class="contents">
      <div class="top-heading-about">
        <div class="about-header">
          <h3>HELP ME IDENTIFY MY <span>ANTIQUE PHONOGRAPH </span></h3>
        </div>
        <div class="abt-items">
          <div class="abt-contents">
            <p>There are hundreds of different antique phonographs. But, with our PhonoWizard, we can help you identify the more common models.    </p>
          </div>
          <div class="abt-contents">
            <p>For further identification assistance and to learn more about your phonograph, post it on our <a href="https://forum.antiquephono.org/">ONLINE FORUM</a>  or <a   style="cursor:pointer;" (click)="openregpage()">JOIN US</a> to access our Library and other Member Resources. </p>
          </div>
          <div class="phono-btn">
            <a  (click)='openbot()' >PhonoWizard</a>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</div>
<!-- end antique -->

<!--  RESOURCES AND RESEARCH -->
<div class="resource">
  <div class="container">
    <div class="resource-heading">
      <h2>RESOURCES AND <span>RESEARCH</span></h2>
    </div>
    <div class="resource-content">
      <p>
        Our Library of over 30,000 searchable pages is a treasure trove of
        information and a prime reason to become a member of the Antique
        Phonograph Society.
      </p>
    </div>
    <div class="btn-session">
      <a routerLink="/catalogs" class="join-btn">LIBRARY</a>
    </div>
  </div>
</div>
<!-- library image -->
<div class="library-image">
  <img src="assets/image/Resources-and-Research@2x.png" alt="" srcset="" />
</div>

<!-- Join us -->
<div class="join">
  <div class="join-header">
    <h2>JOIN <span>US</span></h2>
  </div>
  <div class="join-content">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-5">
          <div class="join-image">
            <img src="assets/image/join-us.png" alt="" srcset="" />
          </div>
        </div>
        <div class="col-lg-8 col-md-7">
          <div class="join-content-item">
            <p>
              Joining the Antique Phonograph Society is one of the best
              investments in machine and music collecting you can make. Members
              enjoy full access to our digital Library, personal copies of our
              quarterly journal, discounts on our events and more. Plus, your
              membership helps our all-volunteer staff keep machine and music
              collecting alive worldwide.
            </p>
            <a   style="cursor:pointer;" (click)="openregpage()"  class="join-btn mt-5">JOIN US</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>





<div>
  <app-contactform id="contactus" ></app-contactform>
</div>
